module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado1.39d68df5.svg";